import React from "react";
import "./App.scss";
import Main from "./containers/Main";
import "./i18n";

function App() {
  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
